import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@heroui/react'

/** A normalized error row — works for both validation errors and terminal request errors. */
export interface BulkInviteErrorRow {
  row?: number
  field?: string
  email?: string
  code: string
  message: string
}

interface RowErrorsTableProps {
  errors: BulkInviteErrorRow[]
}

/**
 * Renders row/field-level errors with the 1-indexed CSV line so the user can find the
 * offending row. Shared by the upload step (validation errors) and the terminal result.
 */
export default function RowErrorsTable({ errors }: RowErrorsTableProps) {
  if (!errors.length) return null

  return (
    <div className="w-full max-h-64 overflow-auto rounded-lg border border-gray-200 dark:border-[#2A2A2A]">
      <Table removeWrapper aria-label="Bulk invite errors" className="min-w-full">
        <TableHeader>
          <TableColumn>Row</TableColumn>
          <TableColumn className="whitespace-nowrap">Field / Email</TableColumn>
          <TableColumn>Error</TableColumn>
        </TableHeader>
        <TableBody>
          {errors.map((error, index) => (
            <TableRow key={`${error.row ?? error.field ?? error.email ?? 'row'}-${index}`}>
              <TableCell className="whitespace-nowrap align-top">{error.row ?? '—'}</TableCell>
              <TableCell className="whitespace-nowrap align-top">
                {error.field || error.email || '—'}
              </TableCell>
              <TableCell className="align-top">{error.message}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
